import React from 'react'

import DynamicFeatureContext from './context'
import { IConfiguration, IDynamicFeatureContextValue } from './types'

interface IDynamicFeatureProviderProps {
  children: React.ReactNode
  configuration: IConfiguration
}

const DynamicFeatureProvider = ({ children, configuration }: IDynamicFeatureProviderProps) => {
  return (
    <DynamicFeatureContext.Provider
      value={
        {
          configuration,
          initialized: true,
        } as IDynamicFeatureContextValue
      }
    >
      {children}
    </DynamicFeatureContext.Provider>
  )
}

export default DynamicFeatureProvider
